import types from "./action-types";
import axios from "axios";
import { showSuccess, showError } from "../../app/toastify";

const isPasswordStrong = (password) => {
  if (
    password &&
    password.length > 7 &&
    // eslint-disable-next-line no-useless-escape
    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password) &&
    /\d/.test(password) &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password)
  )
    return true;
  return false;
};

export const setUser = (data) => {
  return {
    type: types.SET_USER,
    data,
  };
};

export const getEnv = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_ENV, data: null });

      const { data } = await axios.get("/api/env");

      dispatch({ type: types.SET_ENV, data: data.env });
      dispatch({ type: types.SET_VERSION, data: data.version });
    } catch (error) {
      showError(error);
    }
  };
};

export const login = (credentials, history) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data: login } = await axios.post("/api/auth/logins", credentials);

      if (!!login.hasDefaultPassword) {
        dispatch({ type: types.END_LOADING });
        return history.push(`/password-reset?token=${login.token}`);
      }

      try {
        const { data } = await axios.get("/api/auth/users/me");

        dispatch({
          type: types.SET_USER,
          data,
        });

        history.push("/in");
      } catch (error) {}

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const logout = (history) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      await axios.delete("/api/auth/logins");

      dispatch({ type: types.END_LOADING });

      history.push("/");

      dispatch({ type: types.CLEAN_STATE });
      dispatch({ type: types.LOGOUT });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      history.push("/");
    }
  };
};

export const getUser = (history, location) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/auth/users/me");

      dispatch({
        type: types.SET_USER,
        data,
      });

      if (location.pathname === "/") history.push("/in");

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      showError(error);

      if (location.pathname !== "/password-reset") {
        history.push("/");
        await axios.delete("/api/auth/logins");
      }

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.CLEAN_STATE });
      dispatch({ type: types.LOGOUT });
    }
  };
};

export const resetPassword = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post("/api/auth/reset-password", { email });

      showSuccess(data.message);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const changePassword = (credentials, history) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/auth/change-password",
        credentials
      );

      dispatch({ type: types.END_LOADING });

      dispatch({ type: types.SET_STRONG_PASSWORD, data: true });

      showSuccess(data.message);

      history.push("/");
    } catch (error) {
      dispatch({ type: types.SET_STRONG_PASSWORD, data: false });

      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const register = (user, modelDismiss) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post("/api/auth/users", user);

      showSuccess(data.message);

      dispatch({ type: types.END_LOADING });

      modelDismiss.click();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getAcademicYears = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/auth/academic-years");

      dispatch({ type: types.SET_ACADEMIC_YEARS, data });
    } catch (error) {
      showError(error);
    }
  };
};

export const selectAcademicYear = (year, handleCloseAcYearMenu) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      await axios.post("/api/auth/select-academic-year", {
        id: year.id,
      });

      dispatch({
        type: types.SET_SELECTED_ACADEMIC_YEAR,
        data: year,
      });

      handleCloseAcYearMenu();

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });

      showError(error);
    }
  };
};

export const getUserEntities = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/auth/user-entities");

      dispatch({ type: types.SET_USER_ENTITIES, data });
    } catch (error) {
      showError(error);
    }
  };
};

export const selectUserEntity = (entity, handleCloseEntityMenu) => {
  return async (dispatch) => {
    try {
      // dispatch({ type: types.START_LOADING });

      await axios.post("/api/auth/select-user-entity", {
        id: entity.id,
      });

      dispatch({
        type: types.SET_SELECTED_USER_ENTITY,
        data: entity,
      });

      handleCloseEntityMenu();

      // dispatch({ type: types.END_LOADING });
    } catch (error) {
      // dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getUserScopes = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/auth/scopes");

      dispatch({
        type: types.SET_SCOPES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const selectScope = (scope, handleCloseMenu) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      await axios.post("/api/auth/select-scope", {
        id: scope.id,
      });

      // dispatch({
      //   type: types.SET_SELECTED_SCOPE,
      //   data: scope,
      // });

      handleCloseMenu();

      window.location.reload();

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

/**
 * Sidebar features come from the database; inject a CPD report link for roles
 * that already have any /in/cpd feature (same CPD access boundary).
 */
function augmentUserModulesWithCpdReport(menu) {
  if (!Array.isArray(menu)) return menu;
  return menu.map((mod) => {
    if (!mod?.features?.length) return mod;
    const hasCpd = mod.features.some(
      (f) => typeof f.url === "string" && f.url.startsWith("/in/cpd"),
    );
    if (!hasCpd) return mod;
    if (mod.features.some((f) => f.url === "/in/cpd/report")) return mod;
    const orderBase = Math.max(
      0,
      ...mod.features.map((f) => Number(f.orderNo) || 0),
    );
    return {
      ...mod,
      features: [
        ...mod.features,
        {
          id: "CPD_TRAINING_ATTENDANCE_REPORT",
          name: "CPD Report",
          url: "/in/cpd/report",
          orderNo: orderBase + 10,
          permissions: [],
          requiredPermissions: ["CPD_TRAININGS_ATTENDANCE"],
        },
      ].sort(
        (a, b) => (Number(a.orderNo) || 0) - (Number(b.orderNo) || 0),
      ),
    };
  });
}

export const getUserModules = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/auth/user-modules");

      dispatch({
        type: types.SET_USER_MODULES,
        data: augmentUserModulesWithCpdReport(data),
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getRoles = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/auth/roles");

      dispatch({
        type: types.SET_ROLES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const saveRole = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post("/api/auth/roles", formData);

      dispatch({
        type: types.ADD_OR_UPDATE_ROLE,
        data,
      });

      dispatch({ type: types.END_LOADING });

      onClose();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveRolePermissions = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post("/api/auth/role-permissions", formData);

      dispatch({
        type: types.ADD_OR_UPDATE_ROLE,
        data,
      });

      dispatch({ type: types.END_LOADING });

      onClose();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const changeRoleStatus = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post("/api/auth/role-status", formData);

      dispatch({
        type: types.ADD_OR_UPDATE_ROLE,
        data,
      });

      dispatch({ type: types.END_LOADING });

      onClose();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getSupportDeskSettings = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/support-desk/settings/public");
      dispatch({ type: types.SET_SUPPORT_DESK_SETTINGS, data });
    } catch (error) {
      // Fail silently — feature simply stays disabled if API is unreachable
    }
  };
};

export const updateSupportDeskSettings = (payload, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.put("/api/support-desk/settings", payload);
      dispatch({ type: types.SET_SUPPORT_DESK_SETTINGS, data });
      dispatch({ type: types.END_LOADING });
      if (onSuccess) onSuccess(data);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};
